import Model from "../Model";

class ClientsEmployeeZone extends Model{

    buildUrl ({ param }) {
        return ['employeeclientview/getclientsbyzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ClientsEmployeeZone;